import React from 'react'

import './styles.scss'

const TextTooltip = ({ text, textColor, arrowPosition }) => {
  return (
    <div className='text-tooltip'>
      <div className='text-tooltip__content'>
        <p
          className='text-tooltip__text'
          style={{ color: textColor || null }}
        >
          {text}
        </p>
      </div>
      <div
        className='text-tooltip__arrow'
        style={{
          left: arrowPosition === 'left' ? '15px' : null,
          right: arrowPosition === 'right' ? '15px' : null
        }}
      />
    </div>
  )
}

export default TextTooltip
